.popover-grid{display:grid;gap:8px}.sub-header{margin-bottom:8px;display:block}
/*# sourceMappingURL=raster-coding-layer-view-settings-popover.component.css.map */
